import i18n from "@/i18n";

/**
 * Money, written one way across the product.
 *
 * The editor had two: `$0,00` in Jobs & costs and `$4.10` in Video (AI), on the same
 * screen. A dollar amount with a German decimal comma is the odd pairing of the two, so
 * this is the dot — and it lives here rather than being redefined per panel, which is how
 * the two drifted apart to begin with.
 */
export const formatUsd = (amount?: number | null): string =>
	`$${(amount ?? 0).toLocaleString(i18n.language?.startsWith("de") ? "de-DE" : "en-US", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})}`;
